<script setup>

  import { useLocale } from 'vuetify'
  const { t } = useLocale()

</script>

<template>
<div>
<v-card class="bg-white w-100 py-0 px-0 z-index-900 text-center position-fixed elevation-11 rounded-0 floating-contact" v-if="hasSettings" :key="locale"  >
  <v-btn-toggle class="w-100 text-center" rounded="0" theme="light" v-model="toggle" variant="text" v-if="direct[locale]">
    <!-- <template v-for="(item, i) in direct[locale].value" :key="i">
    </template> -->
    <v-btn
      href="tel:+390633220167"
      :id="'mdi-phone-direct-contact'+Math.random()" 
      :title="'mdi-phone-direct-contact'+Math.random()" 
      class="mx-auto"
      @click="trackEvent({name: 'phone'})"
      target="_blank"
      icon="mdi-phone"
    >
    </v-btn>
    <v-btn 
      variant="elevated"
      value="search" 
      id="search-button-nav-direct" 
      title="search-button-nav-direct" 
      href="mailto:info@primerentcar.com" 
      @click="trackEvent({name:'email'})"
      theme="dark" 
      rounded="0"
      class="mx-0 w-50 bg-primary mx-0 px-0"
      color="primary"
      icon="mdi-email">
      
    </v-btn>
  </v-btn-toggle>
</v-card>

    <!-- <v-snackbar
      :timeout="12*1000"
      v-model="activeWhatsapp"
      location="bottom left"
      style="cursor: pointer;"
      color="white"
      rounded="pill"
      v-if="!invalidRoutes.includes($route.name)"
      class="border border-success notification"
      variant="elevated"
      @click.native="openLink(t('notifications.chat.href'))"
    >
    
      <v-icon color="success" class="mx-4 float-start">mdi-whatsapp</v-icon>
      {{ t('notifications.chat.message') }}
   </v-snackbar>

   <v-snackbar
      :timeout="12*1000"
      v-model="activeRequest"
      location="bottom right"
      style="cursor: pointer;"
      class="border border-primary notification"
      color="white"
      v-if="!invalidRoutes.includes($route.name)"
      rounded="pill"
      variant="elevated"
      @click.native="openLink(t('notifications.quotation.href'))"
    >
      <v-icon color="primary" class="mx-4 float-end">mdi-arrow-right</v-icon>
      {{ t('notifications.quotation.message') }}
   </v-snackbar> -->

</div>

</template>

<style scoped>

.floating-contact{
  position: fixed !important;
  bottom: 0;
  left: 0;
  width: 100%;
}

.notification{
  margin-bottom: 70px;
  z-index: 1000 !important;
}
</style>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'floatingContacts',
  computed:{
      ...mapGetters({
          hasSettings: 'settings/hasSettings',
          direct: 'settings/direct',
      })
  },
  data: () => ({
    toggle: 'search',
    locale: localStorage.getItem('locale'),
    invalidRoutes: ['search', 'search-result','search-result-selected'],
    timerActive: null,
    activeWhatsapp: false,
    activeRequest: false,
  }),
  beforeUnmount() {
    clearInterval(this.timerActive)
  },
  mounted(){
        if(!['en','it'].includes(this.locale)){
          this.locale = 'en';
        }

        if(!this.hasSettings){
         this.getSettigns()
        }

        this.timerActive = setInterval(() => {
          this.activeRequest = false
          this.activeRequest = true
          setTimeout(() => {
            this.activeWhatsapp = false
            this.activeWhatsapp = true
          }, 12*1000)
        }, 30*1000)
    
  },
  methods:{
        openLink(link){
          window.open(link, '_blank');
          this.trackEvent(link);
        },
        async getSettigns(){
            await this.$store.dispatch('settings/getSettings')
        },
        trackEvent(item){
            this.$gtm.trackEvent({
                'event':'direct_contact',
                'item': item,
            });
        }
    }
}
</script>